/*=========================================================================================
  File Name: module-internal.js
  Description: internal Module
  ----------------------------------------------------------------------------------------
  Project: MISA Internal
  Author: MISA JSC
  Author URL: http://www.misa.com.vn
==========================================================================================*/

import state from './module-internal-state';
import mutations from './module-internal-mutations';
import actions from './module-internal-actions';
import getters from './module-internal-getters';

export default {
	debug: process.env.NODE_ENV !== 'production',
	namespaced: true,
	state,
	mutations,
	actions,
	getters
};
